export const TIMELINE_ANIMATION_PADDING = 20; // 20px
